<template>
  <div class="copyright-footer p-2" style="height: 40px;">
    <p>Copyright 2026 © TSK Laboratory Taiwan</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.copyright-footer {
  background-color: #fff;
  color: #000;
}
</style>
